package com.cs.ejobin.platform

import kotlinx.browser.window

actual fun passwordResetRedirectUrl(): String {
    val origin = window.location.origin
    return "$origin/reset-password"
}